import {Component} from "./Component";
import {Toast} from "./Toast";
import {createElement} from "../util/html";
import {ScrollAnimations} from "./ScrollAnimations.js";
import {createLogger} from "../util/logger.js";

const console = createLogger("PinForm");

/**
 * Handles pin post form
 */
export class PinForm extends Component {
    static name = "pin-form";

    get name() {
        return PinForm.name;
    }

    constructor(el) {
        super(el);

        this.addEventListener(el, "submit", this.onSubmit.bind(this));
    }

    /**
     *
     * @param {SubmitEvent} e
     */
    onSubmit(e) {
        e.preventDefault();
        e.stopPropagation();
        console.log("onSubmitPin");

        const data = new FormData(e.target);


        fetch(e.target.getAttribute("action"), {
            method: "POST",
            body: data,
        }).then((res) => res.json()).catch(error => {
            console.log("onSubmitPin.error", error);
        }).then(res => {
            console.log("onSubmitPin.result", res);
            // Show toast with response message
            if (res.error) {
                Toast.showToast(res.error.message, "error");
            } else {
                Toast.showToast(res.message, res.pinned ? "success" : "warning", 3000);
            }


            // Replace elements with response html
            Object.keys(res.html || {}).forEach((selector) => {
                const el = Array.from(document.querySelectorAll(selector));
                if (!el) return;

                let newEl = createElement(res.html[selector]);
                newEl = newEl.querySelector(selector) || newEl

                el.forEach(el => el.replaceWith(newEl.cloneNode(true)));

            });

            // Trigger scroll animations so elements are shown when pinned
            requestAnimationFrame(() => {
                ScrollAnimations.updateAnimations(document.body);
            });
        })
    }
}
